<div class="row" [hidden]="to.hidden">
  <div class="col-4" width="5">
    @if (to.scope === 'LOCAL' && to.hidden != true) {
      <button
        class="remove-attribute"
        mat-icon-button
        matTooltip="Remove Attribute"
        tabIndex="-1"
        type="button"
        (click)="removeLocalAttribute()"
        >
        <mat-icon>delete_forever</mat-icon>
      </button>
    }
    @if (to.label && to.hidden != true) {
      <label
        [attr.for]="id"
        class="label"
        [matTooltip]="to.description"
        >
        {{ to.label }}
        @if (to.required && !to.hideRequiredMarker) {
          <span>*</span>
        }
      </label>
    }
  </div>
  <div class="col" width="7">
    <mat-form-field
      [appearance]="to.appearance"
      [attr.data-testid]="to.label"
      [color]="to.color"
      [floatLabel]="to.floatLabel"
      [ngStyle]="{'flex': to.scope === 'LOCAL' ? '1 1 90%' : '1 1 100%', 'max-width': to.scope === 'LOCAL' ? '90%' : '100%', 'box-sizing': 'border-box'}"
      [hideRequiredMarker]="true"
      [matTooltip]="to.tooltip"
      matTooltipShowDelay="2000"
      [ngClass]="getInputCssClass()"
      >
      <ng-container #fieldComponent></ng-container>
      <ng-container matPrefix>
        <ng-container *ngTemplateOutlet="to.prefix ? to.prefix : formlyField._matprefix"></ng-container>
      </ng-container>
      <ng-container matSuffix>
        <ng-container *ngTemplateOutlet="to.suffix ? to.suffix : formlyField._matsuffix"></ng-container>
      </ng-container>
      <!-- fix https://github.com/angular/material2/issues/7737 by setting id to null  -->
      <mat-error [id]="null">
        <formly-validation-message [field]="field"></formly-validation-message>
      </mat-error>
      <!-- fix https://github.com/angular/material2/issues/7737 by setting id to null  -->
      <!-- <mat-hint *ngIf="to.description" [id]="null">{{ to.description }}</mat-hint> -->
    </mat-form-field>
    @if (formlyField.templateOptions.showLocaleIcons && formlyField.templateOptions.localeSupport && to.label !== 'Locked') {
      <emm-language-dialog-icon
        (click)="editLocale()"
      ></emm-language-dialog-icon>
    }
    @if (formlyField.templateOptions.showLocaleIcons && !formlyField.templateOptions.localeSupport && to.label !== 'Locked') {
      <emm-language-global-icon
        (click)="editLocale()"
      ></emm-language-global-icon>
    }
  </div>
</div>
